import { removeItem } from '@storefront/lib-global';
import { sendCheckAvailabilityEvent } from '@storefront/lib-global/utils/gtm/events/check_availability/sendCheckAvailabilityEvent';
import { useSizeAndWidthContext } from '../../../context';
import { PdpActionLink } from '../pdpActionLink/PdpActionLink';

type FindProductInStoreLinkProps = {
  setIsStoreStockOpen: (isOpen: boolean) => void;
  productName: string;
};

export function FindProductInStoreLink({ setIsStoreStockOpen, productName }: FindProductInStoreLinkProps) {
  const { selectedSku, setError, selectedSize, selectedWidth } = useSizeAndWidthContext();

  const handleCheckStock = () => {
    removeItem('pdpStockAvailabilityQuery', 'sessionStorage');

    if (!selectedSku) {
      setError([...(!selectedSize ? ['size'] : []), ...(!selectedWidth ? ['width'] : [])]);
    } else {
      sendCheckAvailabilityEvent({
        step: 'start',
        itemId: selectedSku,
        itemName: productName,
      });
      setIsStoreStockOpen(true);
    }
  };
  return <PdpActionLink onClick={handleCheckStock} testId="storeStockPopUpButton" type="storeStock" />;
}
